<template>
    <!-- 库存盘点 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielInventoryCheckIndex')">
            <template slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="盘点时间">
                        <a-range-picker style="width: 100%;" v-decorator="['date']" showTime></a-range-picker>
                    </a-form-item>
                    <a-form-item label="盘点仓库">
                        <a-select :options="warehouseOptions" placeholder="请选择" v-decorator="['warehouseId']"></a-select>
                    </a-form-item>
                    <a-form-item label="盘点人">
                        <a-input placeholder="请输入" v-decorator="['checkUserName']"></a-input>
                    </a-form-item>
                    
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="search" :loading="searchLoading">筛选</a-button>
                        <a-button @click="handleReset()" :loading="searchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </template>
            <div class="wrap-container-in">
                <div class="mb16">
                    <a-button type="primary" @click="goMaterielInventoryCheck">商品盘点</a-button>
                </div>
                <a-table
                bordered
                :columns="columns"
                :dataSource="dataSource"
                :pagination="pagination"
                :rowKey="record => record.id"
                :loading="searchLoading"
                @change="changePage"
                class="wrap-table"
                >
                    <template slot="index" slot-scope="key, row, index">
                        {{index + 1}}
                    </template>
                    <template slot="actions" slot-scope="key, row">
                        <a v-if="getBtnByAuth('updateStorage')" class="text-primary" @click="goMaterielInventoryCheckDetail(key)">详情</a>
                        <span v-else class="text-disabled">详情</span>
                    </template>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    const columns = [
        {
            title: '序号',
            scopedSlots: { customRender: 'index' }
        },
        {
            title: '盘点时间',
            dataIndex: 'createTime'
        },
        {
            title: '盘点仓库',
            dataIndex: 'warehouseName',
        },
        {
            title: '盘点人',
            dataIndex: 'checkUserName'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    export default {
        name: 'materielInventoryCheckIndex',
        components: {},
        props: {},
        data() {
            return {
                columns,
                warehouseOptions: [],
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                searchLoading: false
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getSelfCheckPage();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getSelfCheckPage();
            },
            search() {
                this.pagination.current = 1;
                this.getSelfCheckPage();
            },
            /**
             * @goMaterielInventoryCheck 跳转商品盘点
             */
            goMaterielInventoryCheck() {
                this.$router.push({name: 'materielInventoryCheck'});
            },
            /**
             * @goMaterielInventoryCheckDetail 跳转盘点详情
             */
            goMaterielInventoryCheckDetail(id) {
                this.$router.push({name: 'materielInventoryCheckDetail', params: {id}});
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        this.warehouseOptions = res.data;
                    }
                });
            },
            /**
             * @getSelfCheckPage 库存盘点记录列表
             */
            getSelfCheckPage() {
                if (!this.shopId) {
                    return false;
                }
                this.filterForm.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.startTime = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.endTime = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    let { current, pageSize } = this.pagination;
                    this.searchLoading = true;
                    this.$api.newStorage.selfCheckPage({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            pageNum: current,
                            pageSize: pageSize,
                        }
                    }).then(res => {
                        if (res && res.data) {
                            this.dataSource = res.data;
                        }
                        this.pagination.total = res.total;
                        this.searchLoading = false;
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },
            /**
             * @selfDeleteCheck 删除库存盘点记录
             */
            selfDeleteCheck(id) {
                this.$api.newStorage.selfDeleteCheck({
                    params: {
                        id
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getSelfCheckPage();
                });
            }
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getWarehouseList();
            this.getSelfCheckPage();
        },
        watch: {
            '$route'(val) {
                val.name == 'materielInventoryCheckIndex' && this.getSelfCheckPage();
            },
            'shopId'() {
                this.pagination.current = 1;
                this.getWarehouseList();
                this.getSelfCheckPage();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
</style>
